import { z } from "zod";

export const choreScheduleSchema = z.object({
  id: z.string(),
  userId: z.string(),
  name: z.string(),
  googleCalendarId: z.string(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type ChoreSchedule = z.infer<typeof choreScheduleSchema>;

export const createChoreScheduleInputSchema = z.object({
  name: z.string().min(1, "Name is required"),
});

export type CreateChoreScheduleInput = z.infer<typeof createChoreScheduleInputSchema>;

export async function listChoreSchedules(): Promise<ChoreSchedule[]> {
  const response = await fetch("/api/chore-schedules", {
    credentials: "include",
  });
  if (!response.ok) throw new Error("Failed to fetch chore schedules");
  return z.array(choreScheduleSchema).parse(await response.json());
}

export async function getChoreSchedule(id: string): Promise<ChoreSchedule> {
  const response = await fetch(`/api/chore-schedules/${id}`, {
    credentials: "include",
  });
  if (!response.ok) throw new Error("Failed to fetch chore schedule");
  return choreScheduleSchema.parse(await response.json());
}

export async function deleteChoreSchedule(id: string): Promise<void> {
  const response = await fetch(`/api/chore-schedules/${id}`, {
    method: "DELETE",
    credentials: "include",
  });
  if (!response.ok) throw new Error("Failed to delete chore schedule");
}

export async function createChoreSchedule(data: CreateChoreScheduleInput): Promise<ChoreSchedule> {
  const response = await fetch("/api/chore-schedules", {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  if (!response.ok) throw new Error("Failed to create chore schedule");
  return choreScheduleSchema.parse(await response.json());
}
